/* tslint:disable */
/* eslint-disable */
/**
 * Web API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: v1.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
import { instanceOfFxIdWebFeaturesGamesChooseGameTurnstileOptions, FxIdWebFeaturesGamesChooseGameTurnstileOptionsFromJSONTyped, FxIdWebFeaturesGamesChooseGameTurnstileOptionsToJSON, } from './FxIdWebFeaturesGamesChooseGameTurnstileOptions';
export function FxIdWebFeaturesGamesChooseGamePortalConfigTurnstileFromJSON(json) {
    return FxIdWebFeaturesGamesChooseGamePortalConfigTurnstileFromJSONTyped(json, false);
}
export function FxIdWebFeaturesGamesChooseGamePortalConfigTurnstileFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    if (instanceOfFxIdWebFeaturesGamesChooseGameTurnstileOptions(json)) {
        return FxIdWebFeaturesGamesChooseGameTurnstileOptionsFromJSONTyped(json, true);
    }
    return {};
}
export function FxIdWebFeaturesGamesChooseGamePortalConfigTurnstileToJSON(json) {
    return FxIdWebFeaturesGamesChooseGamePortalConfigTurnstileToJSONTyped(json, false);
}
export function FxIdWebFeaturesGamesChooseGamePortalConfigTurnstileToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    if (instanceOfFxIdWebFeaturesGamesChooseGameTurnstileOptions(value)) {
        return FxIdWebFeaturesGamesChooseGameTurnstileOptionsToJSON(value);
    }
    return {};
}
//# sourceMappingURL=FxIdWebFeaturesGamesChooseGamePortalConfigTurnstile.js.map